import type { Page, FolderSettings } from '../../types';

interface MoveToFolderDialogProps {
  pageData: Page;
  folderNames: string[];
  folderSettings: Record<string, FolderSettings>;
  onMove: (params: { pageData: Page; folder: string | undefined }) => void;
  onClose: () => void;
}

export function MoveToFolderDialog({
  pageData,
  folderNames,
  folderSettings,
  onMove,
  onClose,
}: MoveToFolderDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm mx-4 w-full" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-lg font-bold text-gray-900 mb-2">In Ordner verschieben</h3>
        <p className="text-gray-500 text-sm mb-4">„{pageData.title}"</p>
        <div className="space-y-1.5">
          <button
            onClick={() => onMove({ pageData, folder: undefined })}
            className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${!pageData.folder ? 'bg-indigo-50 text-indigo-700 font-medium' : 'hover:bg-gray-50 text-gray-700'}`}
          >
            📄 Ohne Ordner
          </button>
          {folderNames.map((name) => {
            const s = folderSettings[name] ?? { icon: '📁', color: 'gray' };
            return (
              <button
                key={name}
                onClick={() => onMove({ pageData, folder: name })}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${pageData.folder === name ? 'bg-indigo-50 text-indigo-700 font-medium' : 'hover:bg-gray-50 text-gray-700'}`}
              >
                {s.icon} {name}
              </button>
            );
          })}
        </div>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}
